import { useId } from "react";

import { cn } from "@/lib/utils";

export default function DetectiveHeroIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[812px] w-[375px]", className)}
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 375 812"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}-a)`}>
        <path d="M0 0h375v812H0z" fill="#fff" />
        <path d="M-2249.5 0H3802v737.145h-6051.5z" fill={`url(#${id}-b)`} />
        <g filter={`url(#${id}-c)`}>
          <ellipse
            cx="148.894"
            cy="420.457"
            fill="#3E2AA3"
            rx="706.417"
            ry="689.108"
          />
        </g>
        <path
          d="M-132.566 373.608a4.856 4.856 0 109.712 0 4.856 4.856 0 00-9.712 0z"
          fill={`url(#${id}-d)`}
        />
        <path
          d="M-243.469 397.108a4.012 4.012 0 108.023 0 4.012 4.012 0 00-8.023 0z"
          fill={`url(#${id}-e)`}
        />
        <path
          d="M-95.725 335.509a2.832 2.832 0 105.664 0 2.832 2.832 0 00-5.664 0z"
          fill={`url(#${id}-f)`}
        />
        <path
          d="M-293.504 299.871a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-g)`}
        />
        <path
          d="M-365.457 255.604a4.248 4.248 0 108.496 0 4.248 4.248 0 00-8.496 0z"
          fill={`url(#${id}-h)`}
        />
        <path
          d="M-334.83 151.184a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-i)`}
        />
        <path
          d="M-223.451 107.714a2.36 2.36 0 104.72 0 2.36 2.36 0 00-4.72 0z"
          fill={`url(#${id}-j)`}
        />
        <path
          d="M-348.065 66.411a3.068 3.068 0 106.135.001 3.068 3.068 0 00-6.135 0z"
          fill={`url(#${id}-k)`}
        />
        <path
          d="M-158.977 209.522a2.597 2.597 0 105.194-.002 2.597 2.597 0 00-5.194.002z"
          fill={`url(#${id}-l)`}
        />
        <path
          d="M-54.725 149.273a3.282 3.282 0 106.564 0 3.282 3.282 0 00-6.564 0z"
          fill={`url(#${id}-m)`}
        />
        <path
          d="M-157.319 149.02a3.535 3.535 0 107.07 0 3.535 3.535 0 00-7.07 0z"
          fill={`url(#${id}-n)`}
        />
        <path
          d="M-392.6 400.781a3.668 3.668 0 107.335.001 3.668 3.668 0 00-7.335-.001z"
          fill={`url(#${id}-o)`}
        />
        <path
          d="M-450.153 191.52a3.283 3.283 0 106.567.001 3.283 3.283 0 00-6.567-.001z"
          fill={`url(#${id}-p)`}
        />
        <path
          d="M-480.297 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-q)`}
        />
        <path
          d="M-507.613 445.626a5.952 5.952 0 1011.905 0 5.952 5.952 0 00-11.905 0z"
          fill={`url(#${id}-r)`}
        />
        <path
          d="M436.113 373.608a4.856 4.856 0 109.713 0 4.857 4.857 0 10-9.713 0z"
          fill={`url(#${id}-s)`}
        />
        <path
          d="M325.21 397.108a4.012 4.012 0 108.023 0 4.012 4.012 0 00-8.023 0z"
          fill={`url(#${id}-t)`}
        />
        <path
          d="M472.954 335.509a2.832 2.832 0 105.664 0 2.832 2.832 0 00-5.664 0z"
          fill={`url(#${id}-u)`}
        />
        <path
          d="M275.175 299.871a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-v)`}
        />
        <path
          d="M203.222 255.604a4.248 4.248 0 108.497 0 4.248 4.248 0 00-8.497 0z"
          fill={`url(#${id}-w)`}
        />
        <path
          d="M211.644 183.753a4.485 4.485 0 108.97-.002 4.485 4.485 0 00-8.97.002z"
          fill={`url(#${id}-x)`}
        />
        <path
          d="M282.255 151.184a3.541 3.541 0 107.082-.002 3.541 3.541 0 00-7.082.002z"
          fill={`url(#${id}-y)`}
        />
        <path
          d="M320.962 238.992a4.13 4.13 0 108.26 0 4.13 4.13 0 00-8.26 0z"
          fill={`url(#${id}-z)`}
        />
        <path
          d="M345.228 107.714a2.36 2.36 0 104.72 0 2.36 2.36 0 00-4.72 0z"
          fill={`url(#${id}-A)`}
        />
        <path
          d="M147.298 149.059a3.069 3.069 0 106.137-.001 3.069 3.069 0 00-6.137.001z"
          fill={`url(#${id}-B)`}
        />
        <path
          d="M409.702 209.522a2.596 2.596 0 105.193 0 2.596 2.596 0 00-5.193 0z"
          fill={`url(#${id}-C)`}
        />
        <path
          d="M513.954 149.273a3.282 3.282 0 106.564 0 3.282 3.282 0 00-6.564 0z"
          fill={`url(#${id}-D)`}
        />
        <path
          d="M475.58 15.732a3.535 3.535 0 107.07-.001 3.535 3.535 0 00-7.07 0z"
          fill={`url(#${id}-E)`}
        />
        <path
          d="M176.079 400.781a3.668 3.668 0 107.335.001 3.668 3.668 0 00-7.335-.001z"
          fill={`url(#${id}-F)`}
        />
        <path
          d="M118.526 191.52a3.283 3.283 0 106.567.001 3.283 3.283 0 00-6.567-.001z"
          fill={`url(#${id}-G)`}
        />
        <path
          d="M36.943 267.397a3.444 3.444 0 106.888 0 3.444 3.444 0 00-6.888 0z"
          fill={`url(#${id}-H)`}
        />
        <path
          d="M11.067 161.655a2.512 2.512 0 105.025.001 2.512 2.512 0 00-5.025-.001z"
          fill={`url(#${id}-I)`}
        />
        <path
          d="M88.382 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-J)`}
        />
        <path
          d="M61.066 445.626a5.952 5.952 0 1011.904 0 5.952 5.952 0 00-11.904 0z"
          fill={`url(#${id}-K)`}
        />
        <g filter={`url(#${id}-L)`}>
          <ellipse
            cx="1157.48"
            cy="218.475"
            fill="#4994D7"
            rx="572.347"
            ry="572.237"
          />
        </g>
        <path
          clipRule="evenodd"
          d="M-992.729 222.944l81.626.234 651.528 1.893 130.603.38 265.754.771 64.194.185 36.178.108 137.716.39 52.3.156c-13.148-2.732-26.121-4.829-38.773-6.41-73.989-9.248-136.696-.741-157.715 2.8-4.898.83-7.55 1.386-7.55 1.386s-2.537-3.093-9.533-6.517c-5.656-2.81-14.314-5.834-26.937-7.581-21.194-2.936-42.854-.048-55.885 2.449-7.551 1.454-12.186 2.781-12.186 2.781s1.836-4.215 2.711-9.278c1.108-6.449.612-14.293-7.317-16.576-14.11-4.068-32.272 0-32.272 0s-24.226-28.79-82.764-33.18c-55.973-4.185-100.867 3.649-104.686 4.351-.175.02-.263.039-.263.039-.262-.224-.524-.458-.787-.683a85.58 85.58 0 00-4.256-3.483c0-.019-.058-.048-.087-.068a115.214 115.214 0 00-12.128-8.146c-25.537-14.946-51.989-31.146-113.384-27.381-83.434 5.113-108.378 45.781-108.378 45.781-95.037-13.971-168.706 11.502-168.706 11.502s-38.335-4.654-74.688 4.663c-19.474 4.986-26.762 13.668-29.328 20.664-.816 2.185-1.166 4.214-1.253 5.902-1.079-1.385-3.294-2.781-7.521-3.776a2.757 2.757 0 00-.234-.058c-12.127-2.742-32.301-1.093-32.301-1.093v-.019c-26.304-44.095-95.369-44.76-115.631-45.134-56.76-1.054-82.868 22.548-122.369 38.363-14.401 5.756-25.392 10.722-31.368 13.522-3.353 1.551-5.131 2.439-5.131 2.439-28.307-8.907-59.179 8.624-59.179 8.624z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.3"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M136.946 254.509c0-.809-.578-1.83-.867-2.239l-.231 2.239-.263.843v1.711l-1.314.385c-.416.511-1.409 1.534-2.045 1.534-.636 0-1.477-1.023-1.818-1.534v1.534l-2.613 2.556c-.455 1.951-1.455 6.068-1.818 6.931-.364.864.606.89 1.136.796.284.416.898 1.284 1.079 1.42.228.17 8.465 1.988 9.318 2.159.852.17 4.147 3.636 7.328 6.647 3.182 3.011 6.193 2.67 7.216 2.67.818 0 1.212 1.25 1.306 1.875l1.193.398 3.182-2.273c1.045.5.966 2.026.795 2.727l-7.499 7.045-1.023-1.818c-.681-.182-6.192-3.863-8.862-5.681l-14.715-2.898c-3.768 4.716-7.456 14.183-11.312 13.892-3.857-.292-11.081-13.381-11.081-13.892 0-.409 1.373-1.534 2.225-2.272v-1.477c-3.954.772-3.807-1.572-3.239-2.841l3.239-2.102 2.045 1.022v2.955l5.511 7.613c-.322-2.746-.966-8.488-.966-9.488s2.5-10.681 3.75-15.396c-1.591-.534-13.589.533-14.182.533-.474 0-2.985-2.392-4.18-3.589.065-.307.197-.968.197-1.152 0-.184.965-.362 1.448-.428l4.544 2.733 5.663-1.712-6.486.23c-.889-.538-2.667-1.745-2.667-2.272 0-.658 1.02-2.634 1.481-2.667.369-.026 2.086 1.175 2.898 1.778l13.545-1.35v-1.514l2.523-1.699 6.457 4.727v-.898c.433-2.047 2.21-5.679 5.851-3.829 3.641 1.849 3.685 4.816 3.251 6.068z"
          fill="#4D0D54"
        />
        <path
          d="M-29.65 361.087v320.049h154.81V337.657H-11.548l-18.101 23.43z"
          fill={`url(#${id}-M)`}
        />
        <path
          d="M-14.03 337.657v343.479h154.809V337.657h-154.81z"
          fill={`url(#${id}-N)`}
        />
        <path
          d="M-7.346 315.013v22.644h141.441v-22.644H-7.345z"
          fill="#1984C0"
        />
        <path
          d="M-20.021 337.657v22.644H146.77v-22.644H-20.021z"
          fill="#70E7FF"
        />
        <path
          d="M46.805 459.605h32.823v59.207H46.805z"
          fill={`url(#${id}-O)`}
        />
        <path
          d="M46.805 459.605h32.823v59.207H46.805z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.705"
        />
        <path d="M44.724 516.146H81.71v4.058H44.724z" fill="#33CBE9" />
        <circle cx="63.374" cy="315.013" fill="#70E7FF" r="27.968" />
        <circle cx="63.375" cy="315.013" fill="#1889C2" r="15.14" />
        <path
          d="M63.291 299.972v30.082m15.223-14.797H48.432"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M-1.271 390.665h34.033v34.033H-1.271z"
          fill={`url(#${id}-P)`}
        />
        <path d="M15.219 389.452v35.925" stroke="#fff" strokeWidth="2.104" />
        <path d="M-3.428 421.933h38.349v4.207H-3.428z" fill="#33CBE9" />
        <path d="M-2.014 407.414H32.45" stroke="#fff" strokeWidth="2.104" />
        <path
          d="M46.253 390.665h34.033v34.033H46.253z"
          fill={`url(#${id}-Q)`}
        />
        <path d="M62.741 389.452v35.925" stroke="#fff" strokeWidth="2.104" />
        <path d="M44.095 421.933h38.349v4.207H44.095z" fill="#33CBE9" />
        <path d="M45.51 407.414h34.464" stroke="#fff" strokeWidth="2.104" />
        <path d="M44.918 568.639h36.745v66.28H44.918z" fill={`url(#${id}-R)`} />
        <path
          d="M44.918 568.639h36.745v66.28H44.918z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path d="M62.72 590.178v45.474" stroke="#fff" strokeWidth="2.271" />
        <path d="M42.589 631.934h41.404v4.542H42.589z" fill="#33CBE9" />
        <path d="M44.115 590.178h37.21" stroke="#fff" strokeWidth="2.271" />
        <path d="M.462 459.605h32.823v59.207H.462z" fill={`url(#${id}-S)`} />
        <path
          d="M.462 459.605h32.823v59.207H.462z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.705"
        />
        <path d="M-1.619 516.146h36.986v4.058H-1.619z" fill="#33CBE9" />
        <path
          d="M-6.604 568.996h36.031v65.567H-6.604z"
          fill="#D9D9D9"
          stroke="#000"
          strokeWidth="0.714"
        />
        <path d="M10.842 590.178v45.474" stroke="#000" strokeWidth="2.142" />
        <path
          d="M-8.933 632.291h40.69v3.828h-40.69z"
          fill="#D9D9D9"
          stroke="#000"
          strokeWidth="0.714"
        />
        <path d="M-7.763 590.178h37.21" stroke="#000" strokeWidth="2.142" />
        <path
          d="M90.255 459.605h32.823v59.207H90.255z"
          fill={`url(#${id}-T)`}
        />
        <path
          d="M90.255 459.605h32.823v59.207H90.255z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.705"
        />
        <path d="M88.174 516.146h36.986v4.058H88.174z" fill="#33CBE9" />
        <path
          d="M93.561 568.639h36.745v66.28H93.561z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path d="M93.561 568.639h36.745v66.28H93.561z" fill={`url(#${id}-U)`} />
        <path d="M111.362 590.178v45.474" stroke="#fff" strokeWidth="2.271" />
        <path d="M91.231 631.934h41.404v4.542H91.231z" fill="#33CBE9" />
        <path d="M92.758 590.178h37.21" stroke="#fff" strokeWidth="2.271" />
        <path
          d="M93.775 390.665h34.033v34.033H93.775z"
          fill={`url(#${id}-V)`}
        />
        <path d="M110.265 389.452v35.925" stroke="#fff" strokeWidth="2.104" />
        <path d="M91.618 421.933h38.349v4.207H91.618z" fill="#33CBE9" />
        <path d="M93.032 407.414h34.464" stroke="#fff" strokeWidth="2.104" />
        <circle cx="11.562" cy="559.708" fill="#33CBE9" r="18.096" />
        <path d="M-9.261 559.708h41.645v87.381H-9.261z" fill="#33CBE9" />
        <path d="M-13.351 559.708h49.826v6.321h-49.826z" fill="#fff" />
        <path
          d="M24.03 584.138v65.443H-.257v-65.443c0-6.707 5.436-12.143 12.143-12.143 6.706 0 12.142 5.436 12.142 12.143z"
          fill="#4D0D54"
          stroke="#000"
          strokeWidth="0.757"
        />
        <path d="M-9.29 646.306h60.08v15.483H-9.29z" fill="#fff" />
        <path d="M-9.29 658.411h74.621v12.036H-9.29z" fill="#fff" />
        <path d="M-9.29 669.458h85.661v11.679H-9.29z" fill="#fff" />
        <path
          d="M209.803 345.526v8.42h160.522v-8.42c-24.182-9.723-39.888-33.323-39.52-59.384l.2-14.183c.267-18.924-15-34.408-33.926-34.408H285.31c-19.081 0-34.604 15.367-34.797 34.448l-.143 14.141c-.264 26.179-16.277 49.619-40.567 59.386z"
          fill="#F16FCE"
        />
        <path d="M202.822 344.168h173.465v9.513H202.822z" fill="#fff" />
        <path
          d="M202.62 353.945V702.01H348.1V353.945H202.62z"
          fill={`url(#${id}-W)`}
        />
        <path
          clipRule="evenodd"
          d="M258.889 353.946V279.73h61.331v74.216h42.075V702.01H216.814V353.946h42.075z"
          fill={`url(#${id}-X)`}
          fillRule="evenodd"
        />
        <path
          d="M229.284 475.248h29.612v60.211h-29.612z"
          fill={`url(#${id}-Y)`}
        />
        <path
          d="M229.284 475.248h29.612v60.211h-29.612z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path d="M227.407 532.747h33.367v4.126h-33.367z" fill="#F16FCE" />
        <path
          d="M273.729 475.248h29.612v60.211h-29.612z"
          fill={`url(#${id}-Z)`}
        />
        <path
          d="M273.729 475.248h29.612v60.211h-29.612z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path d="M271.852 532.747h33.367v4.126h-33.367z" fill="#F16FCE" />
        <path
          d="M318.172 475.248h29.612v60.211h-29.612z"
          fill={`url(#${id}-aa)`}
        />
        <path
          d="M318.172 475.248h29.612v60.211h-29.612z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path d="M316.295 532.747h33.367v4.126h-33.367z" fill="#F16FCE" />
        <path d="M270.17 295.534v47.193h36.73v-47.193h-36.73z" fill="#fff" />
        <path
          d="M273.751 300.135v37.99h29.568v-37.99h-29.568z"
          fill="#4D0D54"
        />
        <path
          d="M231.875 392.922h27.074v48.262h-27.074z"
          fill={`url(#${id}-ab)`}
        />
        <path
          d="M231.875 392.922h27.074v48.262h-27.074z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path
          d="M245.251 392.362v-11.091"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.439"
        />
        <path d="M228.638 438.734h33.548v3.826h-33.548z" fill="#F16FCE" />
        <path
          d="M275.203 392.921h27.074v48.262h-27.074z"
          fill={`url(#${id}-ac)`}
        />
        <path
          d="M275.203 392.921h27.074v48.262h-27.074z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path
          d="M288.579 392.362V381.27"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.439"
        />
        <path d="M271.966 438.733h33.548v3.826h-33.548z" fill="#F16FCE" />
        <path
          d="M273.859 577.024h29.803v53.127h-29.803z"
          fill={`url(#${id}-ad)`}
        />
        <path
          d="M273.859 577.024h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M273.859 597.245h29.803m-14.572 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M288.583 577.105v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path d="M270.296 627.455h36.93v4.211h-36.93z" fill="#F16FCE" />
        <path
          d="M323.218 392.922h27.074v48.262h-27.074z"
          fill={`url(#${id}-ae)`}
        />
        <path
          d="M323.218 392.922h27.074v48.262h-27.074z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="2.751"
        />
        <path
          d="M336.593 392.362v-11.091"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.439"
        />
        <path d="M319.98 438.734h33.548v3.826H319.98z" fill="#F16FCE" />
        <path
          d="M319.836 577.024h29.803v53.127h-29.803z"
          fill={`url(#${id}-af)`}
        />
        <path
          d="M319.836 577.024h29.803v53.127h-29.803z"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth="3.028"
        />
        <path
          d="M319.836 597.245h29.803m-14.573 0v32.802"
          stroke="#fff"
          strokeWidth="2.271"
        />
        <path
          d="M334.561 577.105v-12.21"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.785"
        />
        <path d="M316.272 627.455h36.93v4.211h-36.93z" fill="#F16FCE" />
        <path d="M242.228 265.809h94.656v9.513h-94.656z" fill="#fff" />
        <path
          d="M225.424 605.982c0-10.619 8.608-19.226 19.226-19.226 10.618 0 19.226 8.607 19.226 19.226v62.096h-38.452v-62.096z"
          fill="#F16FCE"
        />
        <path
          d="M242.479 583.191a2.17 2.17 0 012.171-2.17 2.17 2.17 0 012.17 2.17v9.299h-4.341v-9.299z"
          fill="#F16FCE"
        />
        <path
          d="M228.575 606.467c0-8.877 7.197-16.074 16.075-16.074 8.877 0 16.074 7.197 16.074 16.074v51.917h-32.149v-51.917z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M225.424 658.384h-9.629v43.627h9.629v-43.627zm38.452 43.627h97.399v-43.627h-97.399v43.627z"
          fill="#F16FCE"
          fillRule="evenodd"
        />
        <path d="M225.424 667.963h38.452v34.047h-38.452z" fill="#fff" />
        <path
          d="M411.596 551.136c-353.388-38.88-1091.873-7.447-1121.803 23.392l864.884 401.614c923.163-162.483 610.308-386.127 256.919-425.006z"
          fill="#4E4288"
        />
        <path
          clipRule="evenodd"
          d="M287.039 555.874l-40.611.147-324.15 1.189-64.979.239-132.219.484-31.938.117-17.999.067-68.517.245-26.02.098a196.956 196.956 0 0119.29-4.027c36.811-5.81 68.009-.466 78.467 1.759 2.436.521 3.756.871 3.756.871s1.262-1.943 4.743-4.095c2.814-1.765 7.122-3.665 13.402-4.762 10.544-1.845 21.321-.031 27.804 1.538 3.757.914 6.063 1.747 6.063 1.747s-.914-2.648-1.349-5.829c-.551-4.051-.305-8.979 3.64-10.414 7.02-2.556 16.056 0 16.056 0s12.053-18.087 41.177-20.846c27.848-2.629 50.184 2.293 52.084 2.734a.994.994 0 01.131.025c.13-.141.261-.288.391-.429a46.876 46.876 0 012.118-2.189c0-.012.029-.03.044-.043a58.776 58.776 0 016.033-5.118c12.706-9.39 33.171-16.96 63.717-14.594 41.51 3.212 46.615 26.154 46.615 26.154 47.284-8.777 83.935 7.227 83.935 7.227s19.073-2.924 37.16 2.93c9.688 3.132 13.314 8.587 14.591 12.982.406 1.373.58 2.648.623 3.708.537-.87 1.639-1.747 3.742-2.372.029-.012.073-.025.116-.037 6.034-1.722 16.071-.686 16.071-.686v-.013c-.058-.263-.928-4.456.783-9.476 2.596-7.6 11.11-17.088 37.377-17.701 28.239-.662 60.598 12.988 80.251 22.924 7.165 3.616 12.633 6.736 15.606 8.495 1.668.975 2.553 1.532 2.553 1.532 14.083-5.596 29.443 5.419 29.443 5.419z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <ellipse
          cx="282.687"
          cy="723.072"
          fill={`url(#${id}-ag)`}
          rx="104.782"
          ry="6.374"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M233.438 723.037v-6.127l4.564-3.01 1.298 1.066a31.768 31.768 0 004.749 3.224l3.332 1.844a3.334 3.334 0 011.719 2.917v.086h-15.662zm-17.327 0v-6.127l4.564-3.01 1.299 1.066a31.717 31.717 0 004.749 3.224l3.332 1.844a3.334 3.334 0 011.719 2.917v.086h-15.663z"
          fill="#C05E2F"
        />
        <path
          d="M223.243 702.169h17.425l2.376-45.294-18.91 3.066-.891 42.228z"
          fill="#9E5227"
        />
        <path
          d="M228.665 649.627c3.6-.193 11.409-1.186 13.842-3.616l1.286 4.599c-1.286 20.927-.156 38.759-.039 65.264-1.882 1.996-7.49 3.395-11.353 0-2.085-17.857-2.544-35.508-1.438-46.327-3.158 20.502-4.457 40.11-4.269 46.327-2.172 1.562-9.461 2.366-12.57 0-.231-5.438 3.587-47.247 4.143-51.413.556-4.166 6.034-1.662 10.398-14.834z"
          fill="#4D0D54"
        />
        <path
          d="M231.187 613.953l-7.598-1.748 2.058 47.458 15.803-3.485-1.231-24.908-4.189-17.317h-4.843z"
          fill="#CCDAFF"
        />
        <path
          d="M231.682 619.617l-2.368-2.494 1.991-3.05 2.048 3.348-1.671 2.196z"
          fill="#BA3491"
        />
        <path
          d="M235.048 642.471l-2.725-24.178h-1.603l-.802 24.178 2.966 6.325 2.164-6.325z"
          fill="#BA3491"
        />
        <path
          clipRule="evenodd"
          d="M242.219 652.905c-1.884 1.854-9.129 4.901-18.362 1.698-.203-.07-.395-.138-.578-.205-3.105.099-5.321 1.549 1.312 3.849 9.234 3.202 16.479.155 18.362-1.698l-.532-3.701-.208.02.006.037z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M253.528 663.572c1.791-8.227-3.459-16.812-6.308-20.076l-.346 5.942c3.853 4.886 3.909 11.173 3.455 13.706l3.199.428z"
          fill="#9E5227"
        />
        <path
          d="M207.665 700.286l7.008-48.445c.373-2.578.546-5.181.518-7.786l-.335-30.981 3.013-4.454 5.174 5.241 3.164 16.832c.219 7.879.756 24.951 1.151 30.204.394 5.253-1.26 30.204-2.137 42.022-7.954 1.948-14.707 0-17.556-2.633zm42.076-74.563l-5.79-11.244-5.454 15.733 5.079 5.501c6.352 6.88 17.766 1.323 16.269-7.92l-3.254-20.079-2.569-1.716-7.244 5.19 2.963 14.535z"
          fill="#B2682F"
        />
        <path
          d="M202.637 629.231l12.774-16.873 5.993 12.908-9.911 12.68 5.406 13.685-7.515 7.085-8.032-19.664a10.005 10.005 0 011.285-9.821z"
          fill="#B2682F"
        />
        <path
          d="M216.851 667.046c-1.184 0-3.707-4.029-4.092-5.954 0-3.555 2.924-5.706 4.763-6.713l4.234 3.685c-.949 3.762-2.552 8.982-4.905 8.982zm6.148-55.25l2.115-6.488h8.987l4.456 4.301-2.114 6.035-13.444-3.848z"
          fill="#F3898A"
        />
        <path
          d="M220.864 642.257c-2.588-.435-4.68-1.613-5.747-2.378-.656 1.624-.273 3.133 0 3.684 1.556 1.307 2.674.964 5.747 2.056 3.072 1.092 4.159 4.619 4.104 6.068h3.202c.739-5.904-4.719-8.995-7.306-9.43zm.84 10.599c-2.021 4.253-6.142 13.197-6.461 14.946 9.701 5.81 15.572-9.321 6.461-14.946z"
          fill="#9E5227"
        />
        <path
          d="M245.111 614.568l-4.109-4.265c-2.824 1.422-2.975 6.889-2.975 16.118 4.167 29.211 1.675 53.73 0 75.797h7.535c3.441-21.217 4.133-61.966-.451-87.65z"
          fill="#B2682F"
        />
        <path
          d="M231.317 613.961l-8.017-3.499-1.169 1.772 6.965 6.559 2.221-4.832zm0 0l7.579-4.717 1.347 1.575-6.497 7.758-2.429-4.616z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M225.948 603.957c-2.073 0-8.1 2.427-10.557 5.684l3.353 8.048 3.161-1.578-2.496 3.173 7.079 16.99c0-3.59-.209-7.634-.424-11.781-.369-7.136-.754-14.578-.116-20.536zm6.478-1.237c1.519.474 7.847 4.544 10.012 6.593a210.291 210.291 0 00-1.488 8.274l-2.956-1.476 2.662 3.384c-.929 6.235-1.626 13.112-1 16.861-1.536-8.955-3.256-15.951-4.663-21.678-1.16-4.719-2.108-8.577-2.567-11.958z"
          fill="#9E5227"
          fillRule="evenodd"
        />
        <path d="M225.604 601.434h8.407v9.127h-8.407z" fill="#F3898A" />
        <path
          d="M235.467 593.96h2.386l.207 1.26.665-6.859-2.334 1.411-.924 4.188zm-17.565.494l-.284-4.567 4.993.151.202 12.631a10.428 10.428 0 01-4.911-8.215z"
          fill="#4D0D54"
        />
        <ellipse
          fill="#CE5E60"
          rx="1.907"
          ry="3.173"
          transform="rotate(-20.058 1794.606 -327.219) skewX(.041)"
        />
        <ellipse
          fill="#CE5E60"
          rx="1.907"
          ry="3.173"
          transform="matrix(-.93934 -.34298 -.34366 .9391 236.528 595.666)"
        />
        <path
          clipRule="evenodd"
          d="M234.012 609.467a7.285 7.285 0 01-2.718.693 7.308 7.308 0 01-5.69-2.228v-6.498h8.408v8.033z"
          fill="#CE5E60"
          fillRule="evenodd"
        />
        <path
          d="M220.885 590.232l15.965-1.221.033 9.057.008 2.123a7.318 7.318 0 01-14.572.977l-1.434-10.936z"
          fill="#F3898A"
        />
        <path
          d="M227.655 599.243c1.094-.249 2.584.886 3.261 1.691.311-.601 1.219-1.908 2.361-1.843 2.18.126 2.639 3.215 5.023 4.114l-7.355-1.185-7.458 1.585c3.074-.653 1.843-3.832 4.168-4.362z"
          fill="#4D0D54"
        />
        <path
          d="M242.571 594.639a4.832 4.832 0 01-6.283 2.68 4.824 4.824 0 01-2.684-6.275 4.833 4.833 0 016.283-2.68 4.823 4.823 0 012.684 6.275zm-1.317 2.2l4.665 6.494"
          stroke="#fff"
          strokeWidth="1.667"
        />
        <path
          d="M243.36 599.885l3.31 4.597"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3.335"
        />
        <path
          d="M222.223 598.908l.574-9.033-3.38-1.772v3.467l2.806 7.338z"
          fill="#4D0D54"
        />
        <ellipse
          fill="#4D0D54"
          rx="17.39"
          ry="5.49"
          transform="rotate(-8.214 4206.874 -1293.294) skewX(.018)"
        />
        <path
          d="M221.004 574.694c-1.469 4.57-2.893 10.252-3.624 13.433 7.064 1.766 15.168.718 21.455-2.659l-4.32-9.698a2.716 2.716 0 00-4.086-1.085l-.206.15a1.743 1.743 0 01-2.532-.519c-1.895-3.206-5.547-3.169-6.687.378z"
          fill="#F7B119"
        />
        <path
          clipRule="evenodd"
          d="M237.667 582.845l-3.151-7.075a2.717 2.717 0 00-4.087-1.085l-.205.15a1.744 1.744 0 01-2.533-.519c-1.895-3.206-5.547-3.169-6.687.378-1.138 3.54-2.249 7.749-3.032 10.944 6.583 1.277 13.879.222 19.695-2.793z"
          fill={`url(#${id}-ah)`}
          fillRule="evenodd"
        />
        <path
          d="M216.641 649.055l2.552 4.842c-4.15 2.147-5.986 6.235-6.385 8.011l-5.098-1.256c1.429-6.117 6.549-10.28 8.931-11.597z"
          fill="#9E5227"
        />
        <path
          d="M253.444 603.288l1.698 4.405-7.309 3.769-4.459-7.317a3.54 3.54 0 013.865-5.281l1.632.4a6.577 6.577 0 014.573 4.024z"
          fill="#F3898A"
        />
        <path
          d="M245.014 608.695l.397 6.195c7.415.893 12.775-4.586 14.037-6.727l-4.759-3.269c-4.474 4.112-8.314 4.247-9.675 3.801z"
          fill="#9E5227"
        />
        <ellipse
          cx="227.314"
          cy="595.323"
          fill="#4D0D54"
          rx="0.582"
          ry="1.14"
        />
        <path
          d="M-495.419 789.594c-62.704-92.847-162.15 22.03-101.754 62.48 273.295-41.076 514.673-41.847 715.449-43.879 21.607-9.877 21.992-65.128-9.576-81.001-31.57-15.873-51.034 9.26-66.057 22.224-4.938-12.346-27.575-8.848-38.275-5.556-15.538-64.261-80.873-44.543-80.873 0-10.865-14.322-27.574-5.967-34.57 0-3.457-22.224-26.134-22.43-37.041-19.755-35.37-101.944-146.818-47.935-130.26 14.817-10.371-15.31-36.276 4.938-28.396 19.137-21.73-16.298-44.86-6.791-53.708 0-7.324-82.746-120.487-49.312-87.661 20.372-21.73-2.963-40.573 6.206-47.278 11.161z"
          fill="#3FC7C0"
        />
        <path
          d="M23.134 783.415c9.676-.062 28.132-1.958 24.554-9.053-3.577-7.094-17.86 3.079-24.554 9.053z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M-344.326 803.941c-.146-33.279 34.757-48.217 67.519-7.764 5.609-13.463 23.237-11.649 31.351-9.059-.023-69.176 67.529-65.742 74.93-14.813 20.321-13.179 37.535-3.966 43.602 2.288 14.339-18.063 44.16-17.537 54.545 5.569 34.996-59.848 84.533-30.608 68.758 5.691 18.37-2.914 23.14 7.088 23.363 13.807-142.804 10.095-275.639 8.482-364.068 4.281zm372.984-4.926c7.836-1.758 14.233-2.148 19.42-1.505-6.49.527-12.964 1.028-19.42 1.505z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path
          d="M166.878 643.449c-2.632 1.931-6.043 7.998-7.42 10.79l-15.049-5.708c-1.894-2.768 3.469-11.092 6.388-14.908l16.081 9.826z"
          fill="#9EC4E7"
        />
        <path
          d="M150.818 647.961l16.749 10.559c-1.8 1.124-4.508.91-5.637.662-4.755-2.106-13.532-7.909-17.503-10.668a2.375 2.375 0 01-.175-.122l.175.122c1.719 1.085 4.947.099 6.391-.553z"
          fill="#DCECFA"
        />
        <path
          d="M192.259 690.263c.824 6.184-7.157 8.474-11.25 8.846l-4.777-1.842c3.781-1.121 5.979-4.942 5.979-4.942l10.048-2.062z"
          fill="#9EC4E7"
        />
        <path
          d="M174.23 687.929l-11.209 5.014c5.926 9.469 18.961 6.823 24.737 4.317-7.88 2.128-12.282-6.221-13.528-9.331z"
          fill="#DCECFA"
        />
        <path
          d="M335.576 687.061c-3.827 4.262-10.184.054-12.884-2.582l-1.561-4.434c3.037 1.973 7.015 1.229 7.015 1.229l7.43 5.787z"
          fill="#9EC4E7"
        />
        <path
          d="M326.457 673.08l-10.183-4.838c-3.08 9.783 6.539 17.308 11.733 19.847-6.184-4.234-2.979-12.285-1.55-15.009z"
          fill="#DCECFA"
        />
        <path
          clipRule="evenodd"
          d="M-215.203 667.086c31.077-.417 78.932-20.491 78.932-20.491s-8.854-18.679 6.828-28.011c15.682-9.333 20.74 5.078 20.74 5.078s9.764-5.935 26.575-5.078c28.03 1.435 44.208 24.915 54.827 31.855 0 0 19.512-7.253 32.513-3.844 13 3.4 11.352 4.173 26.74 7.432 15.39 3.258 67.043 9.711 67.043 9.711s-225.999 2.714-314.198 3.348z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <g filter={`url(#${id}-ai)`}>
          <path
            clipRule="evenodd"
            d="M77.076 114.069c-1.698.226-3.43.342-5.189.342-21.562 0-39.04-17.479-39.04-39.04 0-14.334 7.724-26.864 19.238-33.654h-.214c-22.404 0-40.565 18.162-40.565 40.565 0 22.404 18.162 40.566 40.565 40.566a40.392 40.392 0 0025.205-8.779z"
            fill={`url(#${id}-aj)`}
            fillRule="evenodd"
          />
        </g>
        <path d="M0 0h375v616H0V0z" fill={`url(#${id}-ak)`} opacity="0.5" />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="776.251"
          x2="776.251"
          y1="26.885"
          y2="867.486"
        >
          <stop stopColor="#FF9877" />
          <stop offset="1" stopColor="#FFC6B5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-d`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-k`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-l`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-m`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-n`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-o`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-p`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-q`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-r`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-s`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-t`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-u`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-v`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-w`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-x`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-y`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-z`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-A`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-B`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-C`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-D`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-E`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-F`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-G`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-H`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-I`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-J`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-K`}
          x1="125.546"
          x2="118.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-M`}
          x1="-29.649"
          x2="13.964"
          y1="281.884"
          y2="532.21"
        >
          <stop stopColor="#70E7FF" />
          <stop offset="1" stopColor="#8036C9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-N`}
          x1="47.933"
          x2="48.766"
          y1="179.457"
          y2="754.044"
        >
          <stop stopColor="#1E69B1" />
          <stop offset="1" stopColor="#0EBDDC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-O`}
          x1="63.216"
          x2="63.216"
          y1="459.605"
          y2="518.812"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-P`}
          x1="15.746"
          x2="15.746"
          y1="390.665"
          y2="424.698"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Q`}
          x1="63.27"
          x2="63.27"
          y1="390.665"
          y2="424.698"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-R`}
          x1="63.29"
          x2="63.29"
          y1="568.639"
          y2="634.919"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-S`}
          x1="16.874"
          x2="16.874"
          y1="459.605"
          y2="518.812"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-T`}
          x1="106.667"
          x2="106.667"
          y1="459.605"
          y2="518.812"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-U`}
          x1="111.933"
          x2="111.933"
          y1="568.639"
          y2="634.919"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-V`}
          x1="110.792"
          x2="110.792"
          y1="390.665"
          y2="424.698"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-W`}
          x1="202.62"
          x2="250.05"
          y1="297.427"
          y2="549.884"
        >
          <stop stopColor="#F16FCE" />
          <stop offset="1" stopColor="#8036C9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-X`}
          x1="362.295"
          x2="170.772"
          y1="868.513"
          y2="845.307"
        >
          <stop stopColor="#C1348C" />
          <stop offset="1" stopColor="#9432A4" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Y`}
          x1="244.09"
          x2="244.09"
          y1="475.248"
          y2="535.459"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Z`}
          x1="288.534"
          x2="288.534"
          y1="475.248"
          y2="535.459"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aa`}
          x1="332.978"
          x2="332.978"
          y1="475.248"
          y2="535.459"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ab`}
          x1="245.412"
          x2="245.412"
          y1="392.922"
          y2="441.184"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ac`}
          x1="288.74"
          x2="288.74"
          y1="392.921"
          y2="441.183"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ad`}
          x1="288.761"
          x2="288.761"
          y1="577.024"
          y2="630.151"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ae`}
          x1="336.755"
          x2="336.755"
          y1="392.922"
          y2="441.184"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-af`}
          x1="334.737"
          x2="334.737"
          y1="577.024"
          y2="630.151"
        >
          <stop stopColor="#892361" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ag`}
          x1="434.335"
          x2="-209.528"
          y1="748.5"
          y2="663.561"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ah`}
          x1="228.483"
          x2="229.456"
          y1="574.56"
          y2="587.641"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#7D2587" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aj`}
          x1="44.191"
          x2="44.191"
          y1="-29.084"
          y2="122.848"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ak`}
          x1="187.5"
          x2="187.5"
          y1="187.22"
          y2="616"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2978.22"
          id={`${id}-c`}
          width="3012.83"
          x="-1357.52"
          y="-1068.65"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_31612"
            stdDeviation="400"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2622.38"
          id={`${id}-L`}
          width="2622.6"
          x="-153.821"
          y="-1092.72"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_31612"
            stdDeviation="369.477"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="145.131"
          id={`${id}-ai`}
          width="129.771"
          x="-20.694"
          y="9.717"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="16" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.682208 0 0 0 0 0.395833 0 0 0 0.93 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_31612"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_31612"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}-a`}>
          <path d="M0 0h375v812H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
